import React from "react";
import UniversalTableLiteWeb from "../../../common/UniversalTableLiteWeb";
import ContentSection from "../../../common/ContentSection";
import withTranslations from "../../../../../hocs/withTranslations";
import PageTitle from "../../../common/PageTitle";
import ResourceResolver from "../../../../../lib/UniversalTable/ResourceResolver";
import { compose } from "redux";
import withUserData from "../../../../../hocs/withUserData";
import { PLAN_PERMISSIONS_NAMES } from "../../../../../redux/modules/auth/userPermissions/selector";
import UpgradePlansWrapper from "../../../landingPage/pages/Plans/components/UpgradePlanWrapper";

const OpsOpdTable = ({ translate, hasPermission }) => {
  return (
    <ContentSection>
      <PageTitle title={translate("ops_opd_page_title")} />
      {hasPermission([PLAN_PERMISSIONS_NAMES.OPS_OPD_TABLE_PAGE]) ? (
        <>
          <h1>{translate("ops_opd_page_header")}</h1>
          <p
            dangerouslySetInnerHTML={{
              __html: translate("ops_opd_page_description")
            }}
          />
          <UniversalTableLiteWeb
            resourceId={ResourceResolver["ops_opd"]}
            useUrlSettings
          />
        </>
      ) : (
        <UpgradePlansWrapper
          permissions={[PLAN_PERMISSIONS_NAMES.OPS_OPD_TABLE_PAGE]}
        />
      )}
    </ContentSection>
  );
};
export default compose(withTranslations, withUserData)(OpsOpdTable);
